export var notificationSuccess = [
    'M6.07 12.3C6.3 12.54 6.7 12.54 6.93 12.3L13.82 5.41C14.06 5.18 14.06 4.78 13.82 4.54L12.98 3.7C12.75 3.46 12.37 3.46 12.14 3.7L6.51 9.32L3.86 6.7C3.63 6.46 3.25 6.46 3.02 6.7L2.18 7.54C1.94 7.78 1.94 8.18 2.18 8.41L6.07 12.3Z',
];
